export default __webpack_public_path__ + "static/media/logodron-escalet-02.92108804.svg";